"use client";

import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getPriorAuthorizationCommsPreview } from "@/src/actions/prior-authorization-comms";
import { getPriorAuthorizationComms } from "@/src/requests/prior-authorization";

export const PRIOR_AUTHORIZATION_COMMS_CACHE_KEY = "prior-authorization-comms";

export function usePriorAuthorizationComms(authDisplayId: string) {
  const query = useQuery({
    queryKey: [PRIOR_AUTHORIZATION_COMMS_CACHE_KEY, authDisplayId],
    queryFn: () => getPriorAuthorizationComms(authDisplayId),
    enabled: !!authDisplayId,
    retry: false,
  });

  return {
    comms: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}

export function usePriorAuthorizationCommsPreview(authDisplayId: string, sentAt: string) {
  return useQuery({
    queryKey: [PRIOR_AUTHORIZATION_COMMS_CACHE_KEY, authDisplayId, "preview", sentAt],
    queryFn: () => getPriorAuthorizationCommsPreview({ authDisplayId, sentAt }),
    enabled: !!(authDisplayId && sentAt),
    retry: false,
  });
}

export function invalidatePriorAuthorizationCommsCache(
  queryClient: ReturnType<typeof useQueryClient>,
  authDisplayId: string
) {
  return queryClient.invalidateQueries({ queryKey: [PRIOR_AUTHORIZATION_COMMS_CACHE_KEY, authDisplayId] });
}
